/* eslint-disable no-undef */
import {
  contractAddress,
  ERC20,
  MarginIssueManager,
  PrimaryIssueManager,
  SecuritiesFactory,
  Security,
} from "@verified-network/verified-sdk";
import { ethers } from "ethers";
import { errorToast, successToast } from "../../utils/constants";
import { ChainConfig, chainDetails } from "../../utils/config";
import SECURITYFACTORYABI from "../../utils/abis/SecurityFactory.json";
import SECURITYABI from "../../utils/abis/Security.json";
import PRIMARYMANAGERABI from "../../utils/abis/primaryManager.json";
import MARGINMANAGERABI from "../../utils/abis/marginManager.json";
import ERC20ABI from "../../utils/abis/ERC20.json";
import { handleCustodyTransaction } from "../../utils/helpers/hextrust";
import { formatBytes32SafeText } from "../../utils/helpers/utils";

export const issueSecurity = async (
  userAddress,
  chainId,
  signer,
  securityCategory,
  securityName,
  securitySymbol,
  currencyAddress,
  issueDpAddress,
  issueCustodianAddress,
  restrictedCountries,
  issueCountry,
  securityType,
  paymentToken,
  provider,
  web3,
  custodyWalletDetails,
) => {
  const abiCoder = new ethers.utils.AbiCoder();
  try {
    const securityFactoryContrect = new SecuritiesFactory(
      signer,
      contractAddress[chainId].SecuritiesFactory,
    );
    if (
      custodyWalletDetails &&
      Object.keys(custodyWalletDetails)?.length > 0 &&
      custodyWalletDetails?.custodyId?.length > 0 &&
      custodyWalletDetails?.address &&
      custodyWalletDetails?.chainId > 0 &&
      web3 &&
      provider &&
      contractAddress[chainId]?.SecuritiesFactory
    ) {
      const securityFactoryContrectWeb3 = new web3.eth.Contract(
        SECURITYFACTORYABI,
        contractAddress[chainId].SecuritiesFactory,
      );
      if (securityFactoryContrectWeb3 && securityFactoryContrect) {
        const txData = securityFactoryContrectWeb3.methods
          .issueSecurity(
            ethers.constants.AddressZero,
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(securityCategory?.toUpperCase()),
            ),
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(securityName),
            ),
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(securitySymbol),
            ),
            currencyAddress,
            userAddress,
            issueDpAddress,
            abiCoder.encode(["bytes32[]"], [restrictedCountries]),
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(issueCountry),
            ),
            securityType.toLowerCase() === "qualified" ? true : false,
          )
          .encodeABI();
        const txNonce = await web3.eth.getTransactionCount(
          custodyWalletDetails?.address,
        );
        return await handleCustodyTransaction(
          custodyWalletDetails,
          contractAddress[chainId]?.SecuritiesFactory,
          provider,
          "0",
          txData,
          web3.utils.toHex(txNonce),
          "Verified-Network-issueSecurity",
        ).then(async (cusRes) => {
          if (cusRes?.toLowerCase() === "completed") {
            successToast(
              "Transaction Successful!",
              "Security issued successfully",
            );
            const response = await securityFactoryContrect.getIssues();
            const securityAddress = response?.response?.result.at(-1);
            return {
              securityAddress,
            };
          } else {
            errorToast(
              "Opps something went wrong",
              "Issue security transaction failed. Try again later",
            );

            return {};
          }
        });
      } else {
        errorToast(
          "Opps something went wrong",
          "Issue security transaction failed. Try again later",
        );

        return {};
      }
    } else {
      if (securityFactoryContrect) {
        return await securityFactoryContrect
          .issueSecurity(
            ethers.constants.AddressZero,
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(securityCategory?.toUpperCase()),
            ),
            formatBytes32SafeText(securityName),
            formatBytes32SafeText(securitySymbol),
            currencyAddress,
            userAddress,
            issueDpAddress,
            abiCoder.encode(["bytes32[]"], [restrictedCountries]),
            ethers.utils.formatBytes32String(
              formatBytes32SafeText(issueCountry),
            ),
            securityType.toLowerCase() === "qualified" ? 1 : 0,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                }
              : {},
          )
          .then(async (res) => {
            if (res?.status === 0) {
              successToast(
                "Transaction Successful!",
                "Security issued successfully",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
              );
              const response = await securityFactoryContrect.getIssues();
              const securityAddress = response?.response?.result.at(-1);
              return {
                securityAddress,
              };
            } else {
              errorToast(
                "Opps something went wrong",
                "Issue security transaction failed. Try again later",
              );

              return {};
            }
          })
          .catch((err) => {
            errorToast(
              "Opps something went wrong",
              "Issue security transaction failed. Try again later",
            );
            console.error(
              "Issue Security Transaction Failed with error: ",
              err,
            );
            return {};
          });
      }
    }

    return {};
  } catch (err) {
    errorToast(
      "Opps something went wrong",
      "Unexpected error!. Try again later",
    );
    console.error("transaction failed with error: ", err);
    return {};
  }
};

export const addSecurityBalance = async (
  chainId,
  userAddress,
  signer,
  securityAddress,
  transferor,
  transferee,
  balanceToAddInWei,
  paymentToken,
  provider,
  web3,
  custodyWalletDetails,
  isSecondary,
  isMargin,
) => {
  try {
    if (
      custodyWalletDetails &&
      Object.keys(custodyWalletDetails)?.length > 0 &&
      custodyWalletDetails?.custodyId?.length > 0 &&
      custodyWalletDetails?.address &&
      custodyWalletDetails?.chainId > 0 &&
      web3 &&
      provider &&
      contractAddress[chainId]?.SecuritiesFactory
    ) {
      const securityFactoryContrectWeb3 = new web3.eth.Contract(
        SECURITYFACTORYABI,
        contractAddress[chainId].SecuritiesFactory,
      );
      if (securityFactoryContrectWeb3) {
        const txData = securityFactoryContrectWeb3.methods
          .addBalance(
            securityAddress,
            transferor,
            transferee,
            Number(balanceToAddInWei),
          )
          .encodeABI();
        const txNonce = await web3.eth.getTransactionCount(
          custodyWalletDetails?.address,
        );
        await handleCustodyTransaction(
          custodyWalletDetails,
          contractAddress[chainId]?.SecuritiesFactory,
          provider,
          "0",
          txData,
          web3.utils.toHex(txNonce),
          "Verified-Network-addBalance",
        ).then((cusRes) => {
          if (cusRes?.toLowerCase() === "completed") {
            successToast(
              "Transaction Successful!",
              "Balance added succesfully",
            );
          } else {
            errorToast(
              "Opps something went wrong",
              "Add balance failed. Try again later",
            );
          }
        });
      }
    } else {
      const securityFactoryContrect = new SecuritiesFactory(
        signer,
        contractAddress[chainId].SecuritiesFactory,
      );

      if (securityFactoryContrect) {
        const totalRemainingBalance =
          BigInt(2n ** 256n - 1n) -
          BigInt(Number(ethers.utils.parseEther("1")));
        const halfRemainingBalance = totalRemainingBalance / 2n;
        const dpBalance =
          halfRemainingBalance + BigInt(Number(ethers.utils.parseEther("1")));

        await securityFactoryContrect
          .addBalance(
            securityAddress,
            transferor,
            transferee,
            isMargin ? dpBalance?.toString() : balanceToAddInWei.toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                }
              : {},
          )
          .then(async (res) => {
            if (res?.status === 0) {
              successToast(
                "Transaction Successful!",
                "Balance added succesfully",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
              );
              if (isSecondary) {
                await securityFactoryContrect
                  .addBalance(
                    securityAddress,
                    transferor,
                    userAddress,
                    balanceToAddInWei.toString(),
                    paymentToken?.address
                      ? {
                          paymentToken: paymentToken?.address,
                          apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                          rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                        }
                      : {},
                  )
                  .then((_res) => {
                    if (_res?.status === 0) {
                      successToast(
                        "Transaction Successful!",
                        "Balance added for issuer succesfully",
                        `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${_res?.response?.hash}`,
                      );
                    } else {
                      errorToast(
                        "Opps something went wrong",
                        "Add balance failed. Try again later",
                      );
                    }
                  })
                  .catch((err) => {
                    errorToast(
                      "Opps something went wrong",
                      "Error while adding balance. Try again later",
                    );
                    console.error("Error while adding balance: ", err);
                  });
              }
              if (isMargin && chainDetails[chainId]?.cfdEscrow?.length > 0) {
                await securityFactoryContrect
                  .addBalance(
                    securityAddress,
                    transferor,
                    chainDetails[chainId]?.cfdEscrow,
                    halfRemainingBalance?.toString(),
                    paymentToken?.address
                      ? {
                          paymentToken: paymentToken?.address,
                          apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                          rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                        }
                      : {},
                  )
                  .then(async (_res) => {
                    if (_res?.status === 0) {
                      successToast(
                        "Transaction Successful!",
                        "Balance added for Escrow succesfully",
                        `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${_res?.response?.hash}`,
                      );
                      const securityContract = new Security(
                        signer,
                        securityAddress,
                      );
                      await securityContract
                        .whiteList(
                          chainDetails[chainId]?.cfdEscrow,
                          (
                            BigInt(2n ** 256n - 1n) - BigInt(balanceToAddInWei)
                          )?.toString(),
                          paymentToken?.address
                            ? {
                                paymentToken: paymentToken?.address,
                                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                                rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                              }
                            : {},
                        )
                        .then(async (__res) => {
                          if (__res?.status === 0) {
                            successToast(
                              "Transaction Successful!",
                              "CFD Escrow whitelisted succesfully",
                              `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${__res?.response?.hash}`,
                            );
                          } else {
                            errorToast(
                              "Opps something went wrong",
                              "Whitelist CFD Escrow failed. Try again later",
                            );
                          }
                        })
                        .catch((err) => {
                          errorToast(
                            "Opps something went wrong",
                            "Error while whitelisting CFD Escrow. Try again later",
                          );
                          console.error(
                            "Error while whitelisting escrow: ",
                            err,
                          );
                        });
                    } else {
                      errorToast(
                        "Opps something went wrong",
                        "Add balance failed. Try again later",
                      );
                    }
                  })
                  .catch((err) => {
                    errorToast(
                      "Opps something went wrong",
                      "Error while adding balance. Try again later",
                    );
                    console.error("Error while adding balance: ", err);
                  });
              }
            } else {
              errorToast(
                "Opps something went wrong",
                "Add balance failed. Try again later",
              );
            }
          })
          .catch((err) => {
            errorToast(
              "Opps something went wrong",
              "Error while adding balance. Try again later",
            );
            console.error("Error while adding balance: ", err);
          });
      }
    }
  } catch (err) {
    errorToast("Opps something went wrong", "Uexpected error. Try again later");
    console.error("Transaction Error: ", err);
  }
};

export const offerSecurityForPrimaryIssue = async (
  userAddress,
  chainId,
  signer,
  securityAddress,
  securitySymbol,
  currencyAddress,
  targetInvestmentRaw,
  minInvestmentRaw,
  issueAmountRaw,
  offerDocumentHash,
  paymentToken,
  provider,
  web3,
  custodyWalletDetails,
) => {
  try {
    const primaryManagerAddress =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    if (
      custodyWalletDetails &&
      Object.keys(custodyWalletDetails)?.length > 0 &&
      custodyWalletDetails?.custodyId?.length > 0 &&
      custodyWalletDetails?.address &&
      custodyWalletDetails?.chainId > 0 &&
      web3 &&
      provider &&
      primaryManagerAddress
    ) {
      const primaryManagerContractWeb3 = new web3.eth.Contract(
        PRIMARYMANAGERABI,
        primaryManagerAddress,
      );

      if (primaryManagerAddress && primaryManagerContractWeb3) {
        const securityContractWeb3 = new web3.eth.Contract(
          SECURITYABI,
          securityAddress,
        );
        const currencyContractWeb3 = new web3.eth.Contract(
          ERC20ABI,
          currencyAddress,
        );
        if (securityContractWeb3 && currencyContractWeb3) {
          const currencyDecimals = await currencyContractWeb3.methods
            .decimals()
            .call();
          const targetInvestment = ethers.utils.parseUnits(
            targetInvestmentRaw.toString(),
            Number(currencyDecimals),
          );
          const minInvestment = ethers.utils.parseUnits(
            minInvestmentRaw.toString(),
            Number(currencyDecimals),
          );
          const issueAmount = ethers.utils.parseEther(
            issueAmountRaw.toString(),
          );

          const txData = securityContractWeb3.methods
            .whiteList(primaryManagerAddress, Number(issueAmount))
            .encodeABI();
          const txNonce = await web3.eth.getTransactionCount(
            custodyWalletDetails?.address,
          );
          await handleCustodyTransaction(
            custodyWalletDetails,
            securityAddress,
            provider,
            "0",
            txData,
            web3.utils.toHex(txNonce),
            "Verified-Network-whiteList",
          ).then(async (cusRes) => {
            if (cusRes?.toLowerCase() === "completed") {
              successToast(
                "Transaction Successful!",
                "Issue manager whitelisted",
              );

              const approveTxData = securityContractWeb3.methods
                .approve(primaryManagerAddress, Number(issueAmount))
                .encodeABI();
              const approveNonce = await web3.eth.getTransactionCount(
                custodyWalletDetails?.address,
              );
              await handleCustodyTransaction(
                custodyWalletDetails,
                securityAddress,
                provider,
                "0",
                approveTxData,
                web3.utils.toHex(approveNonce),
                "Verified-Network-approve",
              ).then(async (cusRes) => {
                if (cusRes?.toLowerCase() === "completed") {
                  successToast(
                    "Transaction Successful!",
                    "Issue manager approved",
                  );
                  const offerTxData = primaryManagerContractWeb3.methods
                    .offer(
                      securityAddress,
                      ethers.utils.formatBytes32String(securitySymbol),
                      Number(issueAmount),
                      currencyAddress,
                      Number(targetInvestment),
                      Number(minInvestment),
                      userAddress,
                      offerDocumentHash,
                    )
                    .encodeABI();
                  const offerNonce = await web3.eth.getTransactionCount(
                    custodyWalletDetails?.address,
                  );
                  await handleCustodyTransaction(
                    custodyWalletDetails,
                    securityAddress,
                    provider,
                    "0",
                    offerTxData,
                    web3.utils.toHex(offerNonce),
                    "Verified-Network-offer",
                  ).then(async (cusRes) => {
                    if (cusRes?.toLowerCase() === "completed") {
                      successToast(
                        "Transaction Successful!",
                        "Security Offered.",
                      );
                    } else {
                      errorToast(
                        "Opps something went wrong",
                        "Offer security failed. Try again later",
                      );
                    }
                  });
                } else {
                  errorToast(
                    "Opps something went wrong",
                    "Approve transaction failed. Try again later",
                  );
                }
              });
            } else {
              errorToast(
                "Opps something went wrong",
                "Whitelist transaction failed. Try again later",
              );
            }
          });
        }
      }
    } else {
      const primaryManagerContract = new PrimaryIssueManager(
        signer,
        primaryManagerAddress,
        "balancer",
      );
      if (primaryManagerAddress && primaryManagerContract) {
        const securityContract = new Security(signer, securityAddress);
        const currencyContract = new ERC20(signer, currencyAddress);
        if (securityContract && currencyContract) {
          const currencyDecimals = await currencyContract
            .decimals()
            .then((res) => res?.response?.result[0]);
          const targetInvestment = ethers.utils.parseUnits(
            targetInvestmentRaw.toString(),
            Number(currencyDecimals),
          );
          const minInvestment = ethers.utils.parseUnits(
            minInvestmentRaw.toString(),
            Number(currencyDecimals),
          );
          const issueAmount = ethers.utils.parseEther(
            issueAmountRaw.toString(),
          );
          await securityContract
            .whiteList(
              primaryManagerAddress,
              issueAmount.toString(),
              paymentToken?.address
                ? {
                    paymentToken: paymentToken?.address,
                    apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                    rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                  }
                : {},
            )
            .then(async (res) => {
              if (res?.status === 0) {
                successToast(
                  "Transaction Successful!",
                  "Issue manager whitelisted",
                  `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                );

                await securityContract
                  .approve(
                    primaryManagerAddress,
                    issueAmount.toString(),
                    paymentToken?.address
                      ? {
                          paymentToken: paymentToken?.address,
                          apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                          rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                        }
                      : {},
                  )
                  .then(async (res) => {
                    if (res?.status === 0) {
                      successToast(
                        "Transaction Successful!",
                        "Issue manager approved",
                        `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                      );

                      await primaryManagerContract
                        .offer(
                          securityAddress,
                          securitySymbol,
                          issueAmount.toString(),
                          currencyAddress,
                          targetInvestment.toString(),
                          minInvestment.toString(),
                          userAddress,
                          offerDocumentHash,
                          paymentToken?.address
                            ? {
                                paymentToken: paymentToken?.address,
                                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                                rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                              }
                            : {},
                        )
                        .then((res) => {
                          if (res?.status === 0) {
                            successToast(
                              "Transaction Successful!",
                              "Security Offered.",
                              `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                            );
                          } else {
                            errorToast(
                              "Opps something went wrong",
                              "Offer security failed. Try again later",
                            );
                          }
                        })
                        .catch((err) => {
                          errorToast(
                            "Opps something went wrong",
                            "Error while offering security. Try again later",
                          );

                          console.error(
                            "Offer Security Transaction Error: ",
                            err,
                          );
                        });
                    } else {
                      errorToast(
                        "Opps something went wrong",
                        "Approve transaction failed. Try again later",
                      );
                    }
                  })
                  .catch((err) => {
                    errorToast(
                      "Opps something went wrong",
                      "Approve transaction error. Try again later",
                    );
                    console.error("Approve Transaction Error: ", err);
                  });
              } else {
                errorToast(
                  "Opps something went wrong",
                  "Whitelist transaction failed. Try again later",
                );
              }
            })
            .catch((err) => {
              errorToast(
                "Opps something went wrong",
                "Whitelist transaction error. Try again later",
              );
              console.error(
                "Whitelist Issue Manager Transaction Failed with error: ",
                err,
              );
            });
        }
      }
    }
  } catch (err) {
    errorToast(
      "Opps something went wrong",
      "Unexpected error. Try again later",
    );
    console.error("Transaction Error: ", err);
  }
};

export const restrictCountriesForSecurity = async (
  chainId,
  web3,
  userAddress,
  securityAddress,
  restrictedCountries,
) => {
  try {
    const securityFactoryContract = new web3.eth.Contract(
      SECURITYFACTORYABI,
      contractAddress[chainId].SecuritiesFactory,
    );
    return await securityFactoryContract.methods
      .restrictCountry(securityAddress, restrictedCountries)
      .send({ from: userAddress })
      .then(async (res) => {
        if (res) {
          successToast(
            "Transaction Successful!",
            "Initialized security details saved",
          );
          return true;
        } else {
          errorToast(
            "Opps something went wrong",
            "Error while saving initialize security. Try again later",
          );

          return false;
        }
      })
      .catch((err) => {
        errorToast(
          "Opps something went wrong",
          "Error while saving initialize security. Try again later",
        );
        console.error("restric countries failed with error: ", err);
        return false;
      });
  } catch (err) {
    errorToast(
      "Opps something went wrong",
      "Unexpected error!. Try again later",
    );
    console.error("restrict countries failed with error: ", err);
    return false;
  }
};

export const offerCollateral = async (
  chainId,
  userAddress,
  signer,
  web3,
  securityAddress,
  currencyAddress,
  collateralAmountFmt,
  paymentToken,
  provider,
  custodyWalletDetails,
) => {
  const marginManagerAddress =
    contractAddress[chainId].BalancerMarginIssueManager;
  if (
    custodyWalletDetails &&
    Object.keys(custodyWalletDetails)?.length > 0 &&
    custodyWalletDetails?.custodyId?.length > 0 &&
    custodyWalletDetails?.address &&
    custodyWalletDetails?.chainId > 0 &&
    web3 &&
    provider &&
    marginManagerAddress &&
    securityAddress &&
    currencyAddress &&
    collateralAmountFmt
  ) {
    const currencyContractWeb3 = new web3.eth.Contract(
      ERC20ABI,
      currencyAddress,
    );
    const marginManagerContractWeb3 = new web3.eth.Contract(
      MARGINMANAGERABI,
      marginManagerAddress,
    );
    const currencyAllowance = await currencyContractWeb3.methods
      .allowance(userAddress, marginManagerAddress)
      .call();
    if (Number(currencyAllowance) < Number(collateralAmountFmt)) {
      const txData = currencyContractWeb3.methods
        .approve(marginManagerAddress, Number(collateralAmountFmt))
        .encodeABI();
      const txNonce = await web3.eth.getTransactionCount(
        custodyWalletDetails?.address,
      );
      return await handleCustodyTransaction(
        custodyWalletDetails,
        currencyAddress,
        provider,
        "0",
        txData,
        web3.utils.toHex(txNonce),
        "Verified-Network-approve",
      ).then(async (cusRes) => {
        if (cusRes?.toLowerCase() === "completed") {
          successToast("Transaction Successful!", "manager approved.");

          const offerTxData = marginManagerContractWeb3.methods
            .offerCollateral(
              currencyAddress,
              Number(collateralAmountFmt),
              securityAddress,
            )
            .encodeABI();
          const offerNonce = await web3.eth.getTransactionCount(
            custodyWalletDetails?.address,
          );

          return await handleCustodyTransaction(
            custodyWalletDetails,
            marginManagerAddress,
            provider,
            "0",
            offerTxData,
            web3.utils.toHex(offerNonce),
            "Verified-Network-offerCollateral",
          ).then(async (cusRes) => {
            if (cusRes?.toLowerCase() === "completed") {
              successToast("Transaction Successful!", "collateral offered.");

              return true;
            } else {
              errorToast(
                "Opps something went wrong",
                "Offer collateral failed. Try again later",
              );
              return false;
            }
          });
        } else {
          errorToast(
            "Opps something went wrong",
            "Manager approval failed. Try again later",
          );
          return false;
        }
      });
    } else {
      const offerTxData = marginManagerContractWeb3.methods
        .offerCollateral(
          currencyAddress,
          Number(collateralAmountFmt),
          securityAddress,
        )
        .encodeABI();
      const offerNonce = await web3.eth.getTransactionCount(
        custodyWalletDetails?.address,
      );

      return await handleCustodyTransaction(
        custodyWalletDetails,
        marginManagerAddress,
        provider,
        "0",
        offerTxData,
        web3.utils.toHex(offerNonce),
        "Verified-Network-offerCollateral",
      ).then(async (cusRes) => {
        if (cusRes?.toLowerCase() === "completed") {
          successToast("Transaction Successful!", "collateral offered.");

          return true;
        } else {
          errorToast(
            "Opps something went wrong",
            "Offer collateral failed. Try again later",
          );
          return false;
        }
      });
    }
  } else {
    if (
      chainId > 0 &&
      userAddress?.length > 0 &&
      signer &&
      web3 &&
      securityAddress &&
      currencyAddress &&
      collateralAmountFmt &&
      marginManagerAddress
    ) {
      const currencyContractWeb3 = new web3.eth.Contract(
        ERC20ABI,
        currencyAddress,
      );
      const marginManagerContract = new MarginIssueManager(
        signer,
        marginManagerAddress,
      );
      const currencyAllowance = await currencyContractWeb3.methods
        .allowance(userAddress, marginManagerAddress)
        .call();
      if (Number(currencyAllowance) < collateralAmountFmt) {
        const currencyContract = new ERC20(signer, currencyAddress);
        return await currencyContract
          .approve(
            marginManagerAddress,
            collateralAmountFmt,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                }
              : {},
          )

          .then(async (res) => {
            if (res?.status === 0) {
              successToast(
                "Transaction Successful!",
                "manager approved.",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
              );
              return await marginManagerContract
                .offerCollateral(
                  currencyAddress,
                  collateralAmountFmt.toString(),
                  securityAddress,
                  paymentToken?.address
                    ? {
                        paymentToken: paymentToken?.address,
                        apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                        rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                      }
                    : {},
                )
                .then((res) => {
                  if (res?.status === 0) {
                    successToast(
                      "Transaction Successful!",
                      "collateral offered.",
                      `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                    );

                    return true;
                  } else {
                    errorToast(
                      "Opps something went wrong",
                      "Offer collateral failed. Try again later",
                    );
                    return false;
                  }
                })
                .catch((err) => {
                  console.log("Offer collateral failed with error: ", err);
                  errorToast(
                    "Opps something went wrong",
                    "Offer collateral failed. Try again later",
                  );

                  return false;
                });
            } else {
              errorToast(
                "Opps something went wrong",
                "Manager approval failed. Try again later",
              );
              return false;
            }
          })
          .catch((err) => {
            console.log("Manager approval failed with error: ", err);
            errorToast(
              "Opps something went wrong",
              "Manager approval failed. Try again later",
            );

            return false;
          });
      } else {
        return await marginManagerContract
          .offerCollateral(
            currencyAddress,
            collateralAmountFmt.toString(),
            securityAddress,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                  rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                }
              : {},
          )
          .then((res) => {
            if (res?.status === 0) {
              successToast(
                "Transaction Successful!",
                "collateral offered.",
                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
              );

              return true;
            } else {
              errorToast(
                "Opps something went wrong",
                "Offer collateral failed. Try again later",
              );
              return false;
            }
          })
          .catch((err) => {
            console.log("Offer collateral failed with error: ", err);
            errorToast(
              "Opps something went wrong",
              "Offer collateral failed. Try again later",
            );

            return false;
          });
      }
    } else {
      console.log("marin manager does not exist for this chain");
      errorToast(
        "Opps something went wrong",
        "Unexpected error!. Try again later",
      );
      return false;
    }
  }
};

export const withdrawCollateral = async (
  chainId,
  userAddress,
  signer,
  web3,
  orderRef,
  securityAddress,
  currencyAddress,
  collateralAmountFmt,
  paymentToken,
  provider,
  custodyWalletDetails,
) => {
  const marginManagerAddress =
    contractAddress[chainId].BalancerMarginIssueManager;
  if (
    custodyWalletDetails &&
    Object.keys(custodyWalletDetails)?.length > 0 &&
    custodyWalletDetails?.custodyId?.length > 0 &&
    custodyWalletDetails?.address &&
    custodyWalletDetails?.chainId > 0 &&
    web3 &&
    provider &&
    marginManagerAddress &&
    securityAddress &&
    currencyAddress &&
    collateralAmountFmt
  ) {
    return false;
  } else {
    if (
      chainId > 0 &&
      userAddress?.length > 0 &&
      signer &&
      web3 &&
      securityAddress &&
      currencyAddress &&
      collateralAmountFmt &&
      marginManagerAddress
    ) {
      const marginManagerContract = new MarginIssueManager(
        signer,
        marginManagerAddress,
      );

      return await marginManagerContract
        .withdraw(
          orderRef,
          securityAddress,
          currencyAddress,
          collateralAmountFmt.toString(),

          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
              }
            : {},
        )
        .then((res) => {
          if (res?.status === 0) {
            successToast(
              "Transaction Successful!",
              "Withdraw collateral successfully",
              `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
            );

            return true;
          } else {
            errorToast(
              "Opps something went wrong",
              "Withdraw collateral failed. Try again later",
            );
            return false;
          }
        })
        .catch((err) => {
          console.log("Withdraw collateral failed with error: ", err);
          errorToast(
            "Opps something went wrong",
            "Offer collateral failed. Try again later",
          );

          return false;
        });
    } else {
      console.log("marin manager does not exist for this chain");
      errorToast(
        "Opps something went wrong",
        "Unexpected error!. Try again later",
      );
      return false;
    }
  }
};
